import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useDevice, useOverlayContext } from 'seagull';
import { PdfViewerModal } from '~/components/PdfViewerModal/pdfViewerModal';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export function useViewInvoicePdf(param) {
    let { invoiceId, invoiceNumber } = param;
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const overlayContext = useOverlayContext();
    const { isMobileDevice } = useDevice();
    const viewInvoicePdf = useCallback(async function() {
        let { showDownloadButton } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const pdfContent = (onClose)=>/*#__PURE__*/ _jsx(PdfViewerModal, {
                title: t.adHocInvoiceApproval.invoiceSummary.invoicePdfTitle({
                    invoiceNumber
                }),
                pdfUniqueName: invoiceId,
                getFileUrl: ()=>api.invoice.downloadPDF(invoiceId),
                onClose: onClose,
                showDownloadButton: showDownloadButton
            });
        if (isMobileDevice) {
            overlayContext.showBottomSheet({
                content: pdfContent(overlayContext.hideBottomSheet)
            });
        } else {
            await overlayContext.showModal({
                biName: 'ad_hoc_invoice_pdf_viewer',
                content: (param)=>{
                    let { dismissModal } = param;
                    return pdfContent(dismissModal);
                }
            });
        }
    }, [
        api,
        invoiceId,
        invoiceNumber,
        isMobileDevice,
        overlayContext,
        t
    ]);
    return {
        viewInvoicePdf
    };
}
